import { useEffect, useState } from "react";

// Import styles
import classes from "./CommentModal.module.scss";

// Import messages
import messages from "./module/messages";

// Import utils
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { ICommentModalProps } from "./module/constants";

const CommentModal = (props: ICommentModalProps) => {
  const { onCancel, onConfirm, show, commentRequired = false } = props;
  const [comment, setComment] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(false);

  useEffect(() => {
    if (show) setComment("");
  }, [show]);

  useEffect(() => {
    if (commentRequired && comment.length === 0) {
      setBtnDisabled(true);
    } else {
      setBtnDisabled(false);
    }
  }, [comment, commentRequired]);

  const confirmCommentModalHandler = () => {
    onConfirm(comment);
  };

  const textareaOnChangeHandler = (event: any) => {
    const tempComment = event.target.value;
    setComment(tempComment);
  };

  return (
    <>
      <Modal show={show} size="lg" centered contentClassName={classes.content}>
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.title} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          <textarea
            className={classes.textarea}
            rows={6}
            maxLength={4000}
            onChange={textareaOnChangeHandler}
            placeholder={"..."}
          />
          <div className={classes["comment-length-container"]}>
            <span>{comment.length} / 4000</span>
          </div>
        </Modal.Body>
        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={onCancel}
          >
            <FormattedMessage {...messages.cancel} />
          </button>
          <button
            disabled={btnDisabled}
            className={`${classes.btn} ${classes["btn-confirm"]}`}
            onClick={confirmCommentModalHandler}
          >
            <FormattedMessage {...messages.confirm} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CommentModal;
